import { render, staticRenderFns } from "./Talk1.vue?vue&type=template&id=34887e98&scoped=true"
import script from "./Talk1.vue?vue&type=script&lang=js"
export * from "./Talk1.vue?vue&type=script&lang=js"
import style0 from "./Talk1.vue?vue&type=style&index=0&id=34887e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34887e98",
  null
  
)

export default component.exports